import { __rest } from "tslib";
import * as React from 'react';
export const Caption = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("caption", Object.assign({ className: className }, props), children));
};
Caption.displayName = 'Caption';
//# sourceMappingURL=Caption.js.map